import { AxiosResponse } from 'axios';

/**
 * エラーレスポンス用のデータを保持するクラス
 */
export default class ErrorResponse {
    /**
     * レスポンスデータ\
     * axiosが生成するレスポンスデータをそのまま保持する想定
     */
    private _response: AxiosResponse;

    /**
     * コンストラクタ
     * @param response レスポンスデータ
     */
    constructor(response: AxiosResponse) {
        this._response = response;
    }

    /**
     * getter http status error かどうか
     */
    public get isHttpError() {
        return this.httpStatusCode >= 400;
    }

    /**
     * getter http status code 取得
     */
    public get httpStatusCode(): any {
        return this._response.status;
    }

    /**
     * getter バックエンドが付与するエラーコード取得
     */
    public get code(): any {
        return this.isHttpError ? this._response.data.code : this._response.data.error_code;
    }

    /**
     * getter バックエンドが付与するエラーのサブコード取得
     */
    public get subcode(): number {
        return this.isHttpError ? this._response.data.subcode : this._response.data.error_subcode;
    }

    /**
     * getter バックエンドが付与するエラーメッセージ取得
     */
    public get message(): string {
        return this.isHttpError ? this._response.data.message : this._response.data.error_message;
    }

    /**
     * getter バックエンドが付与するステータス取得
     */
    public get status(): string {
        return this.isHttpError ? '' : this._response.data.status;
    }
}
